import styles from "./DetailZoneItem.module.scss";
import parkingIcon from "../../assets/images/parking.svg";
import parkingMachine from "../../assets/images/parking-machine.svg";
import infoBoxIcon from "../../assets/images/info-solid.svg";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { getTextRaLevels } from "../TextRaLevels/TextRaLevels";
import { PARK_MACHINE_TYPE } from "../../constants";

type DetailZoneNameProps = {
    code: string;
    sectionCategoryName: string;
    featureType: string;
    sectionID: string;
};

const getIcon = (featureType: string | null = null) => {
    if (featureType === PARK_MACHINE_TYPE.infobox) return infoBoxIcon;
    if (featureType === "parkingMachine") return parkingMachine;
    return parkingIcon;
};

const DetailZoneName: React.FC<DetailZoneNameProps> = ({ ...props }) => {
    const { t } = useTranslation();

    const [textRaLevels, setTextRaLevels] = useState<string>();
    useEffect(() => {
        const fetchRaLevels: () => Promise<void> = async () => {
            setTextRaLevels(await getTextRaLevels(props.sectionID));
        };

        if (props.sectionID) {
            fetchRaLevels();
        }
    }, [props.sectionID]);

    const getZoneTypeLabel = () => {
        if (props.featureType === PARK_MACHINE_TYPE.infobox) {
            return t("home.MapSearchComponent.zones.infoBox");
        }
        if (props.featureType === "parkingZone") {
            return <a href={t("home.MapSearchComponent.zoneInfoLink." + props.sectionCategoryName)} target="_blank">
                {t("home.MapSearchComponent.zones." + props.sectionCategoryName)}
            </a>;
        }
        return props.code.length <= 7
            ? t("home.MapSearchComponent.zones.parkingMachine")
            : t("home.MapSearchComponent.zones.parkingMachineShort");
    }

    return (
        <div className={styles.item}>
            <div className={styles.info}>
                <div className={styles.icon}>
                    <img src={getIcon(props.featureType)} height={24} alt={""} />
                </div>
                <div className={`text-nowrap ${styles.title}`} style={{ display: "flex", justifyContent: "space-between" }}>
                    <div className={styles.placeName}>{props.code}</div>
                </div>
                <div className={`align-items-center ${styles.title}`}>
                    <div className={styles.placeName}>{textRaLevels}</div>
                </div>
                <div className={styles.textEnd}>
                    <span className={styles.textMuted}>{getZoneTypeLabel()}</span>
                </div>
            </div>
        </div>
    );
};

export default DetailZoneName;
